module.exports = __webpack_public_path__ + "static/media/profileDownArrow.2b338486.svg";